import { z } from 'zod';

export const CreateUploadRequest = z.object({
  name: z.string(), // this is not really surfaced in the UI, and instead this is automatically set to the current date: December 17, 2023
});

export type CreateUploadRequest = z.infer<typeof CreateUploadRequest>;

export const UpdateUploadRequest = z.object({
  name: z.string(),
});

export type UpdateUploadRequest = z.infer<typeof UpdateUploadRequest>;

export const UploadStatus = z
  .enum(['NotStarted', 'Processing', 'Failed', 'Complete'])
  .describe('UploadStatus');

export type UploadStatus = z.infer<typeof UploadStatus>;

export const UploadSummary = z.object({
  id: z.string(),
  name: z.string(),
  status: UploadStatus,
});

export type UploadSummary = z.infer<typeof UploadSummary>;

export const UploadUrlSummary = z.object({
  uploadUrl: z.string(),
});

export type UploadUrlSummary = z.infer<typeof UploadUrlSummary>;
